import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBar, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { RxIconModule } from '../rx-icon/rx-icon.module';

@Component({
  selector: 'rx-snackbar',
  templateUrl: './rx-snackbar.component.html',
  styleUrls: ['./rx-snackbar.component.scss'],
  imports: [CommonModule, RxIconModule, MatProgressBarModule],
  standalone: true,
})
export class RxSnackbarComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA)
    public data: {
      text: string;
      dismissText: string;
      progress: { show: boolean; mode: string; perc: number };
    },
    private _snackbar: MatSnackBar,
  ) {}

  public dismiss() {
    this._snackbar.dismiss();
  }
}
